import { createContext } from "preact";
import { useContext } from "preact/hooks";
import type { FormClient } from "./client";
import type { Controller } from "./controller";

export interface FormEnv {
  ctl: Controller;
  client: FormClient;
  versionId: string;
  /** Restplätze je `fieldId:choiceId`. */
  remaining: Record<string, number>;
  /** Recall-Platzhalter auflösen. */
  tpl: (text: string) => string;
}

export const FormContext = createContext<FormEnv | null>(null);

export function useFormEnv(): FormEnv {
  const env = useContext(FormContext);
  if (!env) throw new Error("FormContext fehlt");
  return env;
}
